import React from "react";
import {
  Grid,
  TextField,
  Typography,
  Box,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { useStyles } from "../../campaignModalStyles";
import { i18n } from "../../../../translate/i18n";
import MessageVariablesPicker from "../../../MessageVariablesPicker";

const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

const MessageTabContent = ({
  values,
  setFieldValue,
  touched,
  errors,
  isSubmitting,
  campaignEditable,
  campaign,
  attachment,
  attachmentInfo,
  isFileListSelected,
  attachmentFile,
  handleAttachFile,
  setConfirmationOpen,
  messageTab,
  setMessageTab,
  campaignAiChoice,
}) => {
  const classes = useStyles();

  const handleClickMsgVar = (msgVar) => {
    const el = document.getElementById("message1");
    if (el) {
      const firstHalfText = el.value.substring(0, el.selectionStart);
      const secondHalfText = el.value.substring(el.selectionEnd);
      const newCursorPos = el.selectionStart + msgVar.length;
      setFieldValue("message1", `${firstHalfText}${msgVar}${secondHalfText}`);
      setTimeout(() => {
        el.setSelectionRange(newCursorPos, newCursorPos);
        el.focus();
      }, 100);
    }
  };

  const handleTemplateInsert = (body) => {
    setFieldValue("message1", body);
  };

  // Calcula tokens estimados de salida necesarios para el seed (español ≈ 3 chars/token, × 2.5 margen)
  const estimateRequiredTokens = (charCount) =>
    Math.max(192, Math.ceil((charCount / 3.0) * 2.5));

  const renderMessageField = (
    identifier,
    showAttachmentButton = false,
    customLabel = null,
    aiCompactUx = false,
    compactLayout = false
  ) => {
    const compact = aiCompactUx || compactLayout;
    const messageValue = values[identifier] || "";
    const characterCount = messageValue.length;
    const maxCharacters = 1000;

    return (
      <>
        <TextField
          id={identifier}
          name={identifier}
          fullWidth
          rows={5}
          label={
            customLabel && aiCompactUx ? (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                <span role="img" aria-label={i18n.t("campaigns.dialog.ai.ariaAiEnvironment")}>
                  ✨
                </span>
                {customLabel}
              </span>
            ) : (
              customLabel || i18n.t(`campaigns.dialog.form.${identifier}`)
            )
          }
          placeholder={i18n.t("campaigns.dialog.form.messagePlaceholder")}
          multiline={true}
          variant="outlined"
          disabled={!campaignEditable && campaign.status !== "CANCELADA"}
          value={messageValue}
          onChange={(e) => {
            const newValue = e.target.value;
            if (newValue.length <= maxCharacters) {
              setFieldValue(identifier, newValue);
            }
          }}
          error={touched[identifier] && Boolean(errors[identifier])}
          helperText={touched[identifier] && errors[identifier]}
          className={classes.textField}
          inputProps={{ maxLength: maxCharacters }}
        />
        {/* Contador + variables + adjunto */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 4,
          marginBottom: compact ? 4 : 8,
          flexWrap: compact ? 'wrap' : 'nowrap',
          gap: compact ? 8 : 0,
        }}>
          <div>
            <Typography
              variant="caption"
              style={{ color: characterCount > maxCharacters ? '#d32f2f' : '#666' }}
            >
              Maximo {characterCount}/{maxCharacters} caracteres
              {aiCompactUx && characterCount > 0 && (
                <span style={{ marginLeft: 8, color: '#888' }}>
                  · Tokens IA requeridos: ~{estimateRequiredTokens(characterCount)}
                </span>
              )}
            </Typography>
            <Typography
              variant="caption"
              display="block"
              style={{ color: '#9e9e9e', marginTop: 1 }}
            >
              Spintax: {"{variante1|variante2|variante3}"} para rotación anti-spam
            </Typography>
          </div>
          {(showAttachmentButton || compact) && (
            <div style={{ display: 'flex', alignItems: 'center', gap: compact ? 4 : 8, marginLeft: 'auto' }}>
              {compact && (
                <MessageVariablesPicker
                  variant="iconMenus"
                  disabled={!campaignEditable && campaign.status !== "CANCELADA"}
                  onClick={handleClickMsgVar}
                  onTemplateSelect={handleTemplateInsert}
                />
              )}
              {(campaign.mediaPath || attachment) && showAttachmentButton && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <AttachFileIcon style={{ color: '#666', fontSize: 20 }} />
                  <Typography
                    variant="body2"
                    style={{ color: '#666', display: 'flex', alignItems: 'center', gap: 4 }}
                  >
                    {attachment != null
                      ? (
                          attachmentInfo
                            ? (
                                <>
                                  <span style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {attachmentInfo.fullName || attachmentInfo.name}
                                  </span>
                                  <span style={{ color: '#999', fontSize: '0.875rem' }}>
                                    ({attachmentInfo.size})
                                  </span>
                                </>
                              )
                            : (
                                <>
                                  <span style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {attachment.name}
                                  </span>
                                  <span style={{ color: '#999', fontSize: '0.875rem' }}>
                                    ({formatFileSize(attachment.size)})
                                  </span>
                                </>
                              )
                        )
                      : (
                          <>
                            <span style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {campaign.mediaName}
                            </span>
                            {campaign.mediaSize && (
                              <span style={{ color: '#999', fontSize: '0.875rem' }}>
                                ({formatFileSize(campaign.mediaSize)})
                              </span>
                            )}
                          </>
                        )}
                  </Typography>
                  {campaignEditable && (
                    <IconButton
                      onClick={() => setConfirmationOpen(true)}
                      color="secondary"
                      size="small"
                      style={{ marginLeft: 4 }}
                    >
                      <DeleteOutlineIcon />
                    </IconButton>
                  )}
                </div>
              )}
              {!attachment && !campaign.mediaPath && campaignEditable && showAttachmentButton && (
                <Tooltip title={i18n.t("campaigns.dialog.buttons.attach")}>
                  <span>
                    <IconButton
                      color="primary"
                      aria-label={i18n.t("campaigns.dialog.ai.attachFileAria")}
                      onClick={() => {
                        attachmentFile.current.click();
                        handleAttachFile();
                      }}
                      disabled={isSubmitting || isFileListSelected}
                      size="small"
                    >
                      <AttachFileIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
            </div>
          )}
        </div>
        {!compact ? (
          <MessageVariablesPicker
            disabled={!campaignEditable && campaign.status !== "CANCELADA"}
            onClick={handleClickMsgVar}
          />
        ) : null}
        {/* Aviso de tokens IA — solo en modo semilla IA */}
        {aiCompactUx && characterCount > 0 && (
          <div style={{
            marginTop: 6,
            padding: '8px 12px',
            borderRadius: 6,
            backgroundColor: characterCount > 500 ? '#fff3e0' : '#f0fdf4',
            border: `1px solid ${characterCount > 500 ? '#fb8c00' : '#22c55e'}`,
          }}>
            <Typography variant="caption" style={{ color: characterCount > 500 ? '#e65100' : '#15803d', lineHeight: 1.6 }}>
              {characterCount > 500
                ? <>
                    <strong>⚠️ Mensaje largo detectado.</strong> El sistema necesita ~{estimateRequiredTokens(characterCount)} tokens de output para generar la variación IA.{' '}
                    Ve a <strong>Configuración → Prompts → {'"'}EnvioMasivo{'"'}</strong> y asegúrate de que <strong>Max Tokens ≥ {estimateRequiredTokens(characterCount)}</strong>.
                    Si el Prompt tiene menos tokens configurados, el mensaje se enviará cortado.
                  </>
                : <>
                    <strong>✅ Longitud adecuada.</strong> La IA necesita ~{estimateRequiredTokens(characterCount)} tokens de output para parafrasear este mensaje.
                    El sistema lo ajusta automáticamente.
                  </>
              }
            </Typography>
          </div>
        )}
      </>
    );
  };

  return (
    <Grid xs={12} item>
      {campaignAiChoice === "yes" ? (
        <>
          <Box
            mb={2}
            px={1.5}
            py={1.5}
            bgcolor="action.hover"
            borderRadius={8}
            display="flex"
            alignItems="flex-start"
            style={{ gap: 10 }}
          >
            <span role="img" aria-hidden style={{ fontSize: "1.35rem", lineHeight: 1.25, flexShrink: 0 }}>
              🤖
            </span>
            <Typography variant="body2" component="span" style={{ flex: 1 }}>
              {i18n.t("campaigns.dialog.ai.seedBanner")}
            </Typography>
          </Box>
          {renderMessageField(
            "message1",
            true,
            i18n.t("campaigns.dialog.ai.seedLabel"),
            true
          )}
        </>
      ) : (
        renderMessageField("message1", true, null, false, true)
      )}
    </Grid>
  );
};

export default MessageTabContent;
